// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yZ_j","title":"styles_title__3pkAz"};